import React, { Fragment, useEffect, useState } from 'react';
import { Button, Space, Typography } from 'antd';
import styled from 'styled-components';
import { useSelector } from 'react-redux';

import { TagsSelector } from 'shared/ui/Form';
import { GenericModal } from 'shared/ui/GenericModal';

import { ChatTagProps } from '../interface/chats.interface';
import { useAppDispatch } from '../../../../../store';
import {
    clearSelection,
    selectSelected,
} from '../../../../common/store/selectionSlice';
import {
    useCreateChatTagsMutation,
    useLazyReadChatTagsQuery,
} from '../service/chat.api';

type Props = {
    readonly count: number;
    readonly selectedTags: ChatTagProps[];
};

export const TagsEditor = ({ count, selectedTags }: Props) => {
    const dispatch = useAppDispatch();

    const { selectedRows } = useSelector(selectSelected) as {
        selectedRows: number[];
    };

    const [currentTags, setCurrentTags] = useState(selectedTags);
    const [isOpen, setIsOpen] = useState<boolean>(false);

    const [getTags, { data: tagsData = [] }] = useLazyReadChatTagsQuery();
    const [assignTags] = useCreateChatTagsMutation();

    useEffect(() => {
        if (selectedTags) {
            setCurrentTags(selectedTags);
        }
    }, [selectedTags]);

    useEffect(() => {
        if (isOpen) {
            getTags(null, true);
        }
    }, [isOpen]);

    const handleSubmit = async () => {
        await Promise.all(
            selectedRows.map(community_id =>
                assignTags({
                    community_id: community_id,
                    tags: currentTags.map(tag => tag.name),
                })
            )
        );
    };

    const handleConfirm = () => {
        void handleSubmit();
        setIsOpen(false);
        dispatch(clearSelection());
    };

    const handleCancel = () => {
        setIsOpen(false);
        dispatch(clearSelection());
    };

    const hasError = currentTags.some(t => t.name.length >= 50);

    return (
        <Fragment>
            <Space wrap style={{ width: '100%' }}>
                <Button
                    type='primary'
                    onClick={() => {
                        setIsOpen(true);
                    }}
                >
                    Изменить теги
                </Button>
                <Typography.Text>{`Выбрано чатов: ${count}`}</Typography.Text>
            </Space>

            {isOpen && (
                <GenericModal
                    title={`Изменить теги ${count} чатов`}
                    onConfirm={handleConfirm}
                    onCancel={handleCancel}
                    okButtonProps={{
                        disabled: hasError,
                    }}
                    destroyOnClose
                    width={380}
                    open
                >
                    <p>
                        Видны только теги, относящиеся ко всем выбранным чатам
                    </p>
                    <TagsSelector
                        options={tagsData}
                        value={currentTags}
                        onChange={setCurrentTags}
                    />
                    {hasError && (
                        <StyledError>
                            Длина не должна превышать 50 символов
                        </StyledError>
                    )}
                </GenericModal>
            )}
        </Fragment>
    );
};

const StyledError = styled.p`
    color: #f06e69;
    font-size: 14px;
`;
